<template>
  <ModalLayout icon="delete" title="Delete screenshot?" @close="close">
    <p class="text-center mb-4">Are you sure you want to delete this note? This action cannot be undone.</p>

    <div class="bg-[#F9F9FB] border border-grayNeutralLight rounded p-3 mb-4">
      <p class="text-dark mb-2">{{ meta.note.text }}</p>
      <a v-if="meta.note.link" :href="meta.note.link" target="_blank" class="text-primary text-sm">
        {{ meta.note.link }}
      </a>
      <div v-else>
        {{ meta.note.note }}
      </div>
    </div>

    <template slot="footer">
      <el-button @click="close">Cancel</el-button>
      <el-button type="danger" @click="deleteNote" :loading="loading">Delete</el-button>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from '../ModalLayout.vue'

export default {
  components: { ModalLayout },
  props: {
    meta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async deleteNote() {
      try {
        this.loading = true
        await this.axios.delete(`/api/social-products/social-boost/notes/${this.meta.note.id}`)

        this.$store.dispatch('socialBoostCampaign/getNotes', { flight_id: this.$route.params.flight_id })
        this.close()
        this.$Modal.parent.init()
      } catch (error) {
        if (error?.message) {
          this.$message.error(error.message)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
